<div class="modal-header" id="recipients-modal-title">
    <h3 class="modal-title" id="modal-title" translate="F4M_SUMMARY_MODAL_RECIPIENTS_LABEL"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <fieldset [formGroup]="recipientsGroup">
        <div class="row">
            <div class="col">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="select-column">
                                <div class="checkbox-container">
                                    <input
                                        type="checkbox"
                                        class="form-control"
                                        #checkbox
                                        id="recipients-select-all-checkbox"
                                        [attr.aria-label]="'RECIPIENT_LIST_SELECT_ALL_RECIPIENT_ARIA_LABEL' | translate"
                                        formControlName="checkbox"
                                    />
                                    @if (checkbox.checked) {
                                        <fa-icon [icon]="faCheck" size="2x" (click)="checkbox.click()"></fa-icon>
                                    }
                                </div>
                            </th>
                            <th translate="F4M_PARTICIPANTS_EMAIL"></th>
                            <th class="action-column"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (recipient of recipients; track trackById(i, recipient); let i = $index) {
                            <tr
                                pace-forms-recipient-list-entry
                                [(recipient)]="recipients[i]"
                                [parentForm]="recipientsChildren"
                                (delete)="deleteRecipient(recipients[i].id)"
                                (select)="selectRecipient(recipients[i].id)"
                                (recipientChange)="updateSelectAll()"
                            ></tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex">
                <button
                    class="btn btn-primary"
                    (click)="addRecipient()"
                    [disabled]="recipients.length >= this.maxRecipients"
                    translate="F4M_PARTICIPANTS_ADD_PARTICIPANT"
                ></button>
            </div>
        </div>
    </fieldset>
</div>
<div class="modal-footer" id="modal-footer">
    <button
        class="btn btn-success"
        (click)="saveRecipients()"
        [disabled]="recipientsGroup.invalid || recipientsGroup.pristine"
        translate="RECIPIENTS_SAVE_BUTTON_LABEL"
    ></button>
</div>
